<h1 *ngIf="createProductOrder">Add Product Order Details<button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
<h1 *ngIf="!createProductOrder">Update Product Order Details<button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>

<div class="row" *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
<div class="row" *ngIf="dataLoaded">
    <div class="col-sm-12">
        <form [formGroup]="productOrderForm" (submit)="productOrderSubmit()">
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Patient Name *</label>
                        <input type="text" [readonly]="loading2" formControlName="shipping_customer_name" class="form-control" />
                        <div *ngIf="submitted && f.shipping_customer_name.errors" class="invalid-feedback">
                            <div *ngIf="f.shipping_customer_name.errors.required">Patient Name is required</div>
                        </div>
                        <div *ngIf="(f.shipping_customer_name.value=='NA' || f.shipping_customer_name.value=='N/A') && invalidName"
                            class="invalid-feedback">
                            <div>Please enter valid name</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Patient Mobile *</label>
                        <input type="text" class="form-control" readonly="readonly" formControlName="shipping_phone" />
                        <div *ngIf="submitted && f.shipping_phone.errors" class="invalid-feedback">
                            <div *ngIf="f.shipping_phone.errors.required">Mobile is required</div>
                            <div *ngIf="!f.shipping_phone.valid && f.shipping_phone.value">Invalid Mobile number format
                            </div>
                        </div>
                    </div>

                   
                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Patient Email *</label>
                        <input type="text" class="form-control " formControlName="shipping_email" />
                        <div *ngIf="submitted && f.shipping_email.errors" class="invalid-feedback">
                            <div *ngIf="f.shipping_email.errors.required">Email is required</div>
                            <div *ngIf="!f.shipping_email.valid && f.shipping_email.value">Email format is Invalid</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Order ID *</label>
                        <input type="text" class="form-control " formControlName="order_id" />
                        <div *ngIf="submitted && f.order_id.errors" class="invalid-feedback">
                            <div *ngIf="f.order_id.errors.required"> Order ID is required</div>
                        </div>
                    </div>

                    <div class="col-sm-12 mt-5">
                        <label class="form-label">Address *</label>
                        <textarea class="form-control" formControlName="shipping_address" rows="2"></textarea>
                        <div *ngIf="submitted && f.shipping_address.errors" class="invalid-feedback">
                            <div *ngIf="f.shipping_address.errors.required"> Address is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Pincode *</label>
                        <input type="text" (blur)='checkPinCode()' class="form-control"
                            formControlName="shipping_pincode" />
                        <div *ngIf="submitted && f.shipping_pincode.errors" class="invalid-feedback">
                            <div *ngIf="f.shipping_pincode.errors.required">Pincode is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">City *</label>
                        <input type="text" class="form-control" readonly="readonly" formControlName="shipping_city" />
                        <div *ngIf="submitted && f.shipping_city.errors" class="invalid-feedback">
                            <div *ngIf="f.shipping_city.errors.required">City is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">State *</label>
                        <input type="text" class="form-control" readonly="readonly" formControlName="shipping_state" />
                        <div *ngIf="submitted && f.shipping_state.errors" class="invalid-feedback">
                            <div *ngIf="f.shipping_state.errors.required">State is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Country *</label>
                        <input type="text" class="form-control" readonly="readonly" formControlName="shipping_country" />
                        <div *ngIf="submitted && f.shipping_country.errors" class="invalid-feedback">
                            <div *ngIf="f.shipping_country.errors.required">Country is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Product Name *</label>
                        <input type="text" class="form-control " formControlName="name" />
                        <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                            <div *ngIf="f.name.errors.required">Product Name is required</div>
                        </div>
                    </div>


                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Product Units *</label>
                        <input type="text" class="form-control " formControlName="units" />
                        <div *ngIf="submitted && f.units.errors" class="invalid-feedback">
                            <div *ngIf="f.units.errors.required"> Product Units is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Product Selling Price *</label>
                        <input type="text" class="form-control " formControlName="selling_price" />
                        <div *ngIf="submitted && f.selling_price.errors" class="invalid-feedback">
                            <div *ngIf="f.selling_price.errors.required"> Product Selling price is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Payment Method *</label>
                        <mat-select placeholder="Status" formControlName="payment_method">
                            <mat-option value="cod">COD</mat-option>
                            <mat-option value="prepaid">Prepaid</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.payment_method.errors" class="invalid-feedback">
                            <div *ngIf="f.payment_method.errors.required">Payment method is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Product Sub Total *</label>
                        <input type="text" class="form-control " formControlName="sub_total" />
                        <div *ngIf="submitted && f.sub_total.errors" class="invalid-feedback">
                            <div *ngIf="f.sub_total.errors.required"> Product Sub Total is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Product Length * (Length in cm. Ex - 10)</label>
                        <input type="text" class="form-control " formControlName="length" />
                        <div *ngIf="submitted && f.length.errors" class="invalid-feedback">
                            <div *ngIf="f.length.errors.required"> Product Length is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Product Breadth * (Breadth in cm. Ex - 10)</label>
                        <input type="text" class="form-control " formControlName="breadth" />
                        <div *ngIf="submitted && f.breadth.errors" class="invalid-feedback">
                            <div *ngIf="f.breadth.errors.required"> Product Breadth is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Product Height* (Height in cm. Ex - 10)</label>
                        <input type="text" class="form-control " formControlName="height" />
                        <div *ngIf="submitted && f.height.errors" class="invalid-feedback">
                            <div *ngIf="f.height.errors.required"> Product height is required</div>
                        </div>
                    </div>

                    <div class="col-sm-6 mt-5">
                        <label class="form-label">Product Weight * (Weight in kg. Ex - 1.5 )</label>
                        <input type="text" class="form-control " formControlName="weight" />
                        <div *ngIf="submitted && f.weight.errors" class="invalid-feedback">
                            <div *ngIf="f.weight.errors.required"> Product Weight is required</div>
                        </div>
                    </div>

                </div>
            </div>

            <div *ngIf="createProductOrder" class="card-footer mt-4">
                <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                        class="fa fa-spin fa-spinner"></i> <span *ngIf="createProductOrder"></span>Submit</button>
            </div>
            <div *ngIf="!createProductOrder" class="card-footer mt-4">
                <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                        class="fa fa-spin fa-spinner"></i> <span *ngIf="createProductOrder"></span>Update</button>
            </div>
        </form>
    </div>


</div>